import { fetcher } from "helpers/fetcher";

import {
  TDeleteOrganizationImageReq,
  TDeleteOrganizationImageRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteOrganizationImageProduct = async (
  payload: TDeleteOrganizationImageReq
) => {
  return await fetcher<
    TDeleteOrganizationImageRes,
    TDeleteOrganizationImageReq["data"]
  >(ENDPOINT.CORPORATION.DELETE_ORGANIZATION_IMAGE_PRODUCT, {
    data: payload.data,
    headers: {
      [API_HEADER.CORP_ID]: payload.idCorp,
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.DELETE_ORGANIZATION_IMAGE_PRODUCT.version,
    },
  });
};

export const mutationDeleteOrganizationImageProduct = async (
  payload: TDeleteOrganizationImageReq
) => {
  return (await deleteOrganizationImageProduct(payload)).data.message;
};

mutationDeleteOrganizationImageProduct._key = (
  payload: TDeleteOrganizationImageReq
) => [ENDPOINT.CORPORATION.DELETE_ORGANIZATION_IMAGE_PRODUCT.url, payload];
